import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import store, { RootState } from '../index';
import RobotService from 'services/robot';
import { StatusCode } from 'libs/HTTP/constant';

interface DepartmentStore {
  list: any[];
}
const DefalutData: DepartmentStore = {
  // 机器人列表
  list: []
};

const slice = createSlice({
  name: 'robot',
  initialState: DefalutData,
  reducers: {
    setRobotList: (state, action: PayloadAction<any[]>) => {
      const { payload } = action;
      return { ...state, list: payload };
    }
  }
});
export const robotStore = (state: RootState) => state.robot;
export const { setRobotList } = slice.actions;
export default slice.reducer;

// 获取机器人列表
export const getRobotList = async (data: any = {}) => {
  let res: any = await RobotService.getList(data);
  if (res.code === StatusCode.success) {
    let list = res.data?.list || [];
    // 设置机器人列表
    store.dispatch(setRobotList(list));
  }
  return Promise.resolve(res);
};
